import { useMemo } from 'react'
import { Button, Input } from '@valiant/ui-shared'
import type { AmountInputProps } from './types'

export function AmountInput({
  value,
  onChange,
  balance,
  symbol,
  onPercentageClick,
  selectedPercentage,
}: AmountInputProps) {
  const formattedBalance = useMemo(() => {
    // Remove commas from formatted balance string before parsing
    const num = parseFloat(balance.replace(/,/g, ''))
    return isNaN(num)
      ? '0'
      : num.toLocaleString(undefined, { maximumFractionDigits: 8, minimumFractionDigits: 0 })
  }, [balance])

  return (
    <div>
      <Input
        type="number"
        placeholder="0"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="text-xl md:text-2xl font-bold"
      />
      <div className="flex gap-2 mt-2">
        {[25, 50, 100].map((percentage) => (
          <Button
            key={percentage}
            variant="main_outline"
            size="sm"
            onClick={() => onPercentageClick(percentage)}
            className={`flex-1 ${
              percentage === selectedPercentage && selectedPercentage > 0
                ? 'bg-main/10 border border-main text-main'
                : 'border-card-border text-card-text'
            }`}
          >
            {percentage}%
          </Button>
        ))}
      </div>
      <p className="text-xs text-gray-500 mt-1 text-end">
        {formattedBalance} {symbol} available
      </p>
    </div>
  )
}
